import React from "react";
import {Navigate} from "react-router-dom";
import {getArtistFromPath} from "src/utils/artist.utils";
import {path} from "src/router/path";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(): State {
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("[ErrorBoundary] Caught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const artist = getArtistFromPath(window.location.pathname);
      return <Navigate to={path.error(artist)} replace />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
